
import Vue from "vue";
import eventBus from "../event-bus";
import { ISelectItem } from "../main";
export default Vue.extend({
	data() {
		return {
			rootWidth: 100,
			allTabs: [] as ISelectItem<any>[],
			selectedItem: undefined as ISelectItem<any> | undefined,
		};
	},

	props: {
		tabs: {
			type: Array as () => ISelectItem<any>[],
			default: () => []
		},
		value: {
			type: [Object, Array, Number, String, Boolean]
		},
		loop: {
			type: Boolean
		}
	},

	computed: {
		selectedElementIndex():number {
			if (!this.selectedItem) {
				return -1;
			}
			return this.allTabs.indexOf(this.selectedItem);
		},
		rootElement():HTMLDivElement {
			return this.$refs.root as HTMLDivElement;
		},
		beforeItems():ISelectItem<any>[] {
			if (!this.loop) {
				return this.allTabs.slice(0, this.selectedElementIndex);
			}
			if (!this.selectedItem) {
				return this.allTabs;
			}

			let length = this.tabs.length;
			let beginingPart = this.allTabs.slice(0, length);
			let afterPart = this.allTabs.slice(length, this.allTabs.length);
			if (this.selectedElementIndex < length) {
				let index = beginingPart.indexOf(this.selectedItem);
				var end = beginingPart.slice(0, index);
				var begin = afterPart.slice(index + 1, length);
			} else {
				let index = afterPart.indexOf(this.selectedItem);
				var end = afterPart.slice(0, index);
				var begin = beginingPart.slice(index + 1, length);
			}
			return [...begin, ...end];
		},
		afterItems():ISelectItem<any>[] {
			if (!this.loop)
				return this.allTabs.slice(this.selectedElementIndex + 1, this.tabs.length);
			if (!this.selectedItem) {
				return this.allTabs;
			}

			let length = this.tabs.length;
			let beginingPart = this.allTabs.slice(0, length);
			let afterPart = this.allTabs.slice(length, this.allTabs.length);
			if (this.selectedElementIndex < length) {
				let index = beginingPart.indexOf(this.selectedItem);
				var begin = beginingPart.slice(index + 1, length);
				var end = afterPart.slice(0, index);
			} else {
				let index = afterPart.indexOf(this.selectedItem);
				var begin = afterPart.slice(index + 1, length);
				var end = beginingPart.slice(0, index);
			}
			return [...begin, ...end];
		},
		renderedItems():ISelectItem<any>[] {
			if (!this.selectedItem) {
				return this.allTabs;
			}
			return [...this.beforeItems, this.selectedItem, ...this.afterItems];
		}
	},

	watch: {
		tabs: {
			immediate: true,
			handler() {
				this.generateTabs();
			}
		},
		value: {
			immediate: true,
			handler() {
				if (!this.selectedItem) {
					this.selectedItem = this.allTabs.find(t => t.value == this.value);
					return;
				}
				if (this.value != this.selectedItem.value) {
					this.selectedItem = this.allTabs.find(t => t.value == this.value);
				}
			}
		},
		allTabs: {
			immediate: true,
			handler() {
				this.allTabs.forEach((t, i) => {
					t.key = i + "";
				});
			}
		}
	},

	methods: {
		tabClicked(value:ISelectItem<any>) {
			this.selectedItem = value;
			this.$emit("input", value.value);
		},
		updateValues() {
			let client = this.rootElement.getBoundingClientRect();
			this.rootWidth = client.width;
		},
		generateTabs() {
			if (!this.loop) {
				this.allTabs = this.tabs.map((t, i) => {
					return {
						text: t.text,
						value: t.value,
						key: i + ""
					} as ISelectItem<any>;
				});
				return;
			}
			let allTabs = [
				...this.tabs.map(t => {
					return {
						text: t.text,
						value: t.value
					};
				}),
				...this.tabs.map(t => {
					return {
						text: t.text,
						value: t.value
					};
				})
			] as ISelectItem<any>[];

			allTabs.forEach((t, i) => {
				t.key = i + "";
			});

			this.allTabs = allTabs;
		}
	},

	mounted() {
		eventBus.$on("resize", this.updateValues);
		this.updateValues();
	}
});
